import { render, staticRenderFns } from "./UfSelect.vue?vue&type=template&id=6763198b&"
import script from "./UfSelect.vue?vue&type=script&lang=js&"
export * from "./UfSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports